import { render, staticRenderFns } from "./TransactionsMobile.vue?vue&type=template&id=16215cec&scoped=true"
import script from "./TransactionsMobile.vue?vue&type=script&lang=js"
export * from "./TransactionsMobile.vue?vue&type=script&lang=js"
import style0 from "./TransactionsMobile.vue?vue&type=style&index=0&id=16215cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16215cec",
  null
  
)

export default component.exports